import { render } from "./shc-technical-analysis.vue?vue&type=template&id=153fc040"
import script from "./shc-technical-analysis.js?vue&type=script&lang=js&external"
export * from "./shc-technical-analysis.js?vue&type=script&lang=js&external"

import "./shc-technical-analysis.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__